/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */

import { getBaseServiceConfig } from 'apps/console-core/src/Services/_base';
import { useJobRunnerServiceStore } from 'dxpConsoleCore-mf/State';
import { JobRunnerService } from '../../JobRunner.service';
import { JobRunnerServiceConfiguration } from '../../JobRunner.service.config';

/**
 * Get the Job Runner Service.
 */
export const getJobRunnerService = (): JobRunnerService => {
  const baseServiceConfig = getBaseServiceConfig();

  const { updateJobRunnerService } = useJobRunnerServiceStore.getState();
  const { jobRunnerService }: { jobRunnerService: JobRunnerService | null } = useJobRunnerServiceStore.getState();

  if (!jobRunnerService) {
    const jobRunnerServiceConfig: JobRunnerServiceConfiguration = baseServiceConfig;
    const newJobRunnerService = new JobRunnerService(jobRunnerServiceConfig);
    updateJobRunnerService(newJobRunnerService);

    return newJobRunnerService;
  }

  return jobRunnerService;
};
